export const setItemToStorage = (key: string, val: any) => {
  localStorage.setItem(key, JSON.stringify(val));
};

export const getItemfromStorage = (key: string) => {
  return JSON.parse(localStorage.getItem(key) || '{}');
};
//expects a stringified string
export const getMultiLineString = (val: any) => {
  if (isStringified(val) && typeof val === 'string') {
    return JSON.parse(val.replace('\\n', '<br>'))
      .toString()
      .replace('<br>', '\n');
  } else {
    return val;
  }
};

//expects a stringified string
export const getMultiLineStringForDisplayInGrid = (val: any) => {
  if (isStringified(val)) return JSON.parse(val.replace('\\n', ' '));
  else return val;
};

export const isStringified = (val: any) => {
  try {
    JSON.parse(val);
    return true;
  } catch (e) {
    return false;
  }
};
